import instance from "./ApiServices";
import authHeader from "./auth-header";

const getAllfood = () => {
  return instance.get("/search-menucategory/food", { headers: authHeader() });
};

const getAlldrinks = () => {
  return instance.get("/search-menucategory/drinks", { headers: authHeader() });
};

const getAllcategories = () => {
  return instance.get("/menucategories", { headers: authHeader() });
};

const get = (id) => {
  return instance.get(`/menuitems/${id}`, { headers: authHeader() });
};

const create = (data) => {
  return instance.post("/menuitems", data, { headers: authHeader() });
};

const update = (id, data) => {
  return instance.post(`/menuitems/${id}?_method=PUT`, data, {
    headers: authHeader(),
  });
};

const remove = (id) => {
  return instance.delete(`/menuitems/${id}`, { headers: authHeader() });
};

const removeAll = () => {
  return instance.delete(`/menuitems`);
};

const findByTitle = (title) => {
  return instance.get(`/menuitems?title=${title}`);
};

const FoodDrinkService = {
  getAllfood,
  getAlldrinks,
  get,
  create,
  update,
  remove,
  removeAll,
  findByTitle,
  getAllcategories,
};

export default FoodDrinkService;
